import React from 'react';
import { Typography } from 'antd';

const { Title, Paragraph, Text } = Typography;

const BRAND = '#25D366';
const BRAND_DARK = '#128C7E';
const INK = '#0b1f1a';

export default function TermsPage() {
  return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      <div style={{
        background: `linear-gradient(135deg, ${BRAND_DARK} 0%, ${BRAND} 100%)`,
        color: '#fff', padding: '40px 20px',
      }}>
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
          <div style={{ fontSize: 34, marginBottom: 6 }}>⚽</div>
          <Title level={1} style={{ color: '#fff', margin: 0 }}>Termos de Uso</Title>
          <Text style={{ color: 'rgba(255,255,255,0.85)' }}>
            Futezap Comunidade · Atualizado em 20/08/2026
          </Text>
        </div>
      </div>

      <div style={{ maxWidth: 720, margin: '0 auto', padding: '32px 20px 60px', color: INK }}>

        <Title level={3}>1. Sobre o Futezap Comunidade</Title>
        <Paragraph>
          O Futezap Comunidade é uma rede que conecta boleiros e times de futebol amador.
          Aqui você cria um perfil, aparece no mapa da sua região, se candidata a jogos,
          recebe convites e constrói reputação através de avaliações.
        </Paragraph>
        <Paragraph>
          O cadastro e uso são <strong>gratuitos</strong>. Nunca cobramos você por jogar,
          se candidatar ou receber convite. Alguns times podem usar o produto pago
          "Futezap Pro" (automação de convocação por WhatsApp), mas isso é opção do time,
          não afeta seu uso como jogador.
        </Paragraph>

        <Title level={3}>2. Quem pode se cadastrar</Title>
        <Paragraph>
          Você precisa ter <strong>16 anos ou mais</strong>. Se for menor de 18, o cadastro
          exige autorização dos pais/responsáveis. Menores de 16 não são elegíveis.
        </Paragraph>

        <Title level={3}>3. Sua conta</Title>
        <Paragraph>
          Você cria a conta usando Google, e-mail ou celular (via código OTP no WhatsApp).
          Uma conta serve pra dois papéis: <strong>jogador</strong> (buscar times, aceitar convites)
          e/ou <strong>dono de time</strong> (cadastrar time, receber candidatos). É o mesmo login.
        </Paragraph>
        <Paragraph>
          Você é responsável pela segurança da sua conta. Não compartilhe credenciais.
          Se algo estranho acontecer (login não reconhecido, mensagens que você não mandou),
          nos avise imediatamente.
        </Paragraph>

        <Title level={3}>4. Dados que a gente coleta</Title>
        <Paragraph>
          Pra funcionar, coletamos:
        </Paragraph>
        <ul>
          <li><strong>Nome, e-mail e telefone</strong> — pra identificação e contato</li>
          <li><strong>Localização (CEP)</strong> — pra mostrar times/boleiros próximos no mapa</li>
          <li><strong>Posição, nível e foto</strong> — informação pública do teu perfil</li>
          <li><strong>Histórico de jogos e avaliações</strong> — pra tua reputação na comunidade</li>
        </ul>
        <Paragraph>
          <strong>Endereço exato só é mostrado quando você e o time confirmam interesse mútuo</strong>
          (convite aceito). Antes disso, o mapa mostra só sua região aproximada.
        </Paragraph>

        <Title level={3}>5. Como a gente usa esses dados</Title>
        <ul>
          <li>Mostrar teu perfil pros times/boleiros próximos (só quando público)</li>
          <li>Enviar convites e mensagens de convocação</li>
          <li>Notificar você por push/e-mail sobre atividades relevantes</li>
          <li>Estatísticas agregadas da comunidade (números totais, nunca identificando você)</li>
        </ul>
        <Paragraph>
          <strong>Não vendemos seus dados</strong> pra terceiros. Não usamos pra anúncios de fora.
        </Paragraph>

        <Title level={3}>6. Convivência na comunidade</Title>
        <Paragraph>
          É proibido:
        </Paragraph>
        <ul>
          <li>Ofensas, discriminação, assédio ou qualquer forma de violência verbal</li>
          <li>Cadastro com informações falsas ou perfis fakes</li>
          <li>Spam, comportamento automatizado ou uso indevido dos convites</li>
          <li>Compartilhar dados pessoais de outros usuários</li>
        </ul>
        <Paragraph>
          Denunciar comportamentos inadequados é obrigação de todos. Contas que descumprirem
          podem ser suspensas ou removidas sem aviso.
        </Paragraph>

        <Title level={3}>7. Reputação e avaliações</Title>
        <Paragraph>
          Depois de cada jogo, os participantes podem se avaliar. As notas são visíveis
          publicamente na sua ficha. Avaliações injustas ou coordenadas pra prejudicar
          alguém podem ser removidas pela moderação.
        </Paragraph>

        <Title level={3}>8. Contato e privacidade</Title>
        <Paragraph>
          Você pode a qualquer momento:
        </Paragraph>
        <ul>
          <li>Editar seu perfil e ocultar do mapa (deixar "não público")</li>
          <li>Solicitar exclusão da conta e dos seus dados</li>
          <li>Pedir uma cópia dos seus dados</li>
        </ul>
        <Paragraph>
          Basta abrir contato pelo WhatsApp de suporte na tela de perfil.
        </Paragraph>

        <Title level={3}>9. Limitação de responsabilidade</Title>
        <Paragraph>
          O Futezap Comunidade é uma plataforma de conexão. <strong>Não somos responsáveis
          pelo que acontece nos jogos</strong> (lesões, brigas, cobrança de valores entre
          jogadores). Cada partida é acordo direto entre os envolvidos.
        </Paragraph>
        <Paragraph>
          Fazemos o melhor pra manter o serviço no ar, mas eventualmente pode ter
          interrupções técnicas. Não garantimos disponibilidade 100%.
        </Paragraph>

        <Title level={3}>10. Alterações nestes termos</Title>
        <Paragraph>
          A gente pode atualizar estes termos com o tempo. Sempre que rolar mudança
          importante, você é avisado por push/e-mail. Continuar usando depois da mudança
          significa que aceitou a nova versão.
        </Paragraph>

        <div style={{
          marginTop: 40, padding: 20, background: '#f5f7fa', borderRadius: 12,
          textAlign: 'center', color: '#5a6a63', fontSize: 13,
        }}>
          Dúvidas? Fala com a gente pelo WhatsApp de suporte na tela do teu perfil.<br/>
          Feito no Brasil 🇧🇷 pra quem joga bola.
        </div>
      </div>
    </div>
  );
}
